'use strict';
const angular = require('angular');

/*@ngInject*/
export function VoterGroupsService($resource) {
  return $resource('/api/voter-groups/:id', {
    name: '@_id'
  },{
    getWithData: {
      method: 'GET',
      url: "/api/voter-groups/:id/data"
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduu.VoterGroupsService', [])
  .factory('VoterGroupsService', VoterGroupsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/voter-groups/voter-groups.service.js